module.exports = __webpack_public_path__ + "static/media/5.c201a2a6.png";